import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_NcSedCheckList = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_NcSedCheckList' className='file-pdf-document'>
            <div className='file-template'>



                <p><center><h3>North Carolina Juvenile Justice Determination Criteria Checklist for <br />Severe Emotional Disturbance (SED)</h3></center></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Individual's Name</span>
                            <input type='text' id="txtIndividual" name="txtIndividual" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Birthdate</span>
                            <input type='date' id="txtBirthdate" name="txtBirthdate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>NC-JOIN Number</span>
                            <input type='text' id="txtJoinNumber" name="txtJoinNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    The following checklist illustrates the criteria that shall be met for an individual to be designated as SED. To make an SED designation, Sections 1 and 2 are required and at least two of five in Section 3.
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbSection1" name="cbSection1" className='add-only' value="Section1" />
                    SECTION 1: Age
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection2" name="cbSection2" className='add-only' value="Section2" />
                        </td>
                        <td className='w-730'>Under the age of 18,
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> OR </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection3" name="cbSection3" className='add-only' value="Section3" />
                        </td>
                        <td className='w-730'>between the ages of 18 and 21 and receiving services prior to 18th birthday which must be continued for therapeutic benefit.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbSection4" name="cbSection4" className='add-only' value="Section4" />
                    SECTION 2: Clinical Symptoms
                </p>
                <p className='w-750'>
                    The individual presents with either:
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection5" name="cbSection5" className='add-only' value="Section5" />
                        </td>
                        <td className='w-730'>A clinically significant disorder of thought, mood, perception, orientation, memory or behavior that is listed in the current edition of the American Psychiatric Association Diagnostic and Statistical Manual of Mental Disorders (DSM).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <ul>
                                <li>Exclude diagnoses of intellectual disability, other developmental disability, or substance use diagnosis only.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> OR </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection6" name="cbSection6" className='add-only' value="Section6" />
                        </td>
                        <td className='w-730'>Clinically significant symptoms of complex trauma, defined as exposure to multiple or prolonged traumatic events, which are often invasive and interpersonal in nature. Complex trauma exposure involves the simultaneous or sequential occurrence of child maltreatment, including psychological maltreatment, neglect, exposure to violence, and physical and sexual abuse.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbSection7" name="cbSection7" className='add-only' value="Section7" />
                    SECTION 3: Functional Impairments
                </p>
                <p className='w-750'>
                    The individual presents with substantial limitations in at least 2 of the following 5 areas that have persisted for at least 1 year or are judged by a behavioral health professional to be at high risk of continuing for 1 year without professional intervention:
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection8" name="cbSection8" className='add-only' value="Section8" />
                        </td>
                        <td className='w-730'>
                            <b>Functioning in self-care:</b> Impairment in self-care is manifested by a person's consistent inability to provide, sustain and protect his or herself at a level appropriate to his or her age. Examples include significant basic hygiene or self-care needs, patterns of self-injurious behavior, patterns of physically reckless decision making, disordered eating behaviors, failure to address serious health, nutrition, safety, or medical needs, or threats or attempts at suicide.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection9" name="cbSection9" className='add-only' value="Section9" />
                        </td>
                        <td className='w-730'>
                            <b>Functioning in Interpersonal Relationships:</b> Impairment of interpersonal relationships (including community relationships) is manifested by the consistent inability to develop and maintain satisfactory relationships with peers and adults. Children and adolescents exhibit constrictions in their capacities for shared attention, engagement, initiation of two-way effective communication, and shared social problem solving. Inability to maintain safety without assistance; a consistent lack of behavioral controls, decision-making, judgment and value systems that is clearly inappropriate to the individual's age (e.g., repeated or serious aggressive interactions with peers or adults in the community, isolated or withdrawn much of the time, behavior which consistently alienates peers);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection10" name="cbSection10" className='add-only' value="Section10" />
                        </td>
                        <td className='w-730'>
                            <b>Functioning in Family Life:</b> Impairment in family function is manifested by severe difficulties in living in a family or family type environment. This can include a pattern of emotional or disruptive behavior exemplified by repeated and/or unprovoked aggravating or violent behaviors aimed at others in the home (siblings and/or parents and/or other caretakers such as relative caregivers, foster parents) and seriously disrupts the home; disregard for safety and welfare of self or others in the home (e.g., fire setting, serious and chronic destructiveness, self-injurious behavior, inability to conform to reasonable expectations that may result in removal from the family or its equivalent);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection11" name="cbSection11" className='add-only' value="Section11" />
                        </td>
                        <td className='w-730'>
                            <b>Functioning at School/Work:</b> Impairment in school/work function is manifested by an inability to pursue educational goals in a normal time frame (e.g., consistently failing grades, repeated truancy, expulsion, property damage, or violence toward others); the ability to learn social and intellectual skills from teachers in available educational settings (e.g., failing most courses--or some courses, if performance is significantly below ability, dropped out of school without alternative academic or vocational involvement or has serious attendance problems, behavior problems result in frequent intervention or suspensions, special class placement or expulsion); or inability to be consistently employed at a developmentally appropriate level (e.g., inability to conform to work schedule, poor relationships with supervisor and other workers, hostile behavior on the job);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection12" name="cbSection12" className='add-only' value="Section12" />
                        </td>
                        <td className='w-730'>
                            <b>Functioning in Self-Direction:</b> Impairment in self-direction is manifested by an inability to control behavior and make decisions in a manner appropriate to his or her age. (e.g., repeated or serious violations of the law or community norms; lacks confidence or competence to perform routine age-appropriate functions in the community such as running an errand; behavior is repeatedly disruptive or inappropriate in community settings; requires adult supervision in community well after age when should have more autonomy). Allegations of lawbreaking behavior which have not been substantiated by a finding of delinquency should not be relied upon to score this criterion.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    NOTE: For early childhood functioning, major impairments undermine the fundamental foundation of healthy functioning exhibited by:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Rarely or minimally seeking comfort in distress
                        </li>
                        <li>Limited positive affect and excessive levels of irritability, sadness or fear
                        </li>
                        <li>Disruptions in feeding and sleeping patterns
                        </li>
                        <li>Failure, even in unfamiliar settings, to check back with adult caregivers after venturing away
                        </li>
                        <li>Willingness to go off with an unfamiliar adult with minimal or no hesitation
                        </li>
                        <li>Regression of previously learned skills
                        </li>
                        <li>Inability to make and keep friends
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection13" name="cbSection13" className='add-only' value="Section13" />
                        </td>
                        <td className='w-730'>This individual does not meet the criteria for the designation of Severe Emotional Disability (SED). Documentation of the existence of these criteria of Age, Diagnosis, Disability and Duration is present in the individual's medical record and assessment has been conducted by a qualified, licensed behavioral health professional.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbSection14" name="cbSection14" className='add-only' value="Section14" />
                        </td>
                        <td className='w-730'>This individual does meet the criteria for the designation of Severe Emotional Disability (SED). Documentation of the existence of these criteria of Age, Diagnosis, Disability and Duration is present in the individual's medical record and assessment has been conducted by a qualified, licensed behavioral health professional.
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Name of Qualified Behavioral Health Professional (Printed)</td>
                        <td className='small w-250'>Date of Evaluation</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature of Qualified Behavioral Health Professional</td>
                    </tr>
                </table>
                <p className='w-750'>
                    Sources: Kentucky Determination Criteria Checklist for Severe Emotional Disturbance <br /> (https://dbhdid.ky.gov/dbh/documents/cmc/2015/Blevins2.pdf) 
                </p>
                <p className='w-750'>
                    New Mexico Behavioral Health Collaborative SED Criteria Checklist <br />(https://newmexico.networkofcare.org/content/client/1446/Tab%207--SED%20Criteria%20Change.pdf)
                </p>
                <p className='w-750'>
                    Contact Information: Peter Kuhns, NC Juvenile Justice Director of Clinical Services and Programs <br /> (peter.kuhns@ncdps.gov)
                </p>
                <p className='w-750'>
                    Benjamin Locklair, Senior Psychologist, NCDHHS Justice Systems Innovation <br /> (Benjamin.locklair@dhhs.nc.gov)
                </p>





            </div>
        </form>

    )
}  
